import styled from 'styled-components'

const BottomTabNavigationStyle = styled.div`
    --tabNavPaddingV: calc(0.5 * var(--sp1x));
    --tabNavPaddingH: var(--sp2x);
    --tabNavMiddleBgSize: -30%;

    --headerBookmarkActiveIconSize: var(--sp1x);

    display: inline-flex;
    position: fixed;
    align-items: center;
    bottom: var(--sp3x);
    left: 50%;
    padding: var(--tabNavPaddingV) var(--tabNavPaddingH);
    background: var(--primaryColor3);
    transform: translateX(-50%);
    border-radius: var(--sp1x);
    box-shadow: 0px 3px 6px var(--shadowColor);
    z-index: 99999;

    > * {
        margin: 0 var(--sp1x);
    }

    .middle-icon {
        position: relative;
        display: flex;
        padding: calc(0.5 * var(--sp1x));
        margin: 0 var(--sp2x);

        &:before {
            content: '';
            position: absolute;
            top: var(--tabNavMiddleBgSize);
            left: var(--tabNavMiddleBgSize);
            right: var(--tabNavMiddleBgSize);
            bottom: var(--tabNavMiddleBgSize);
            background: var(--secondaryColor3);
            border-radius: var(--sp1x);
        }
    }
    
    .link-item {
        display: flex;

        [class^=giz-] {
            line-height: 1;
        }

        .giz-bookmarks {
            position: relative;

            &:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                width: var(--headerBookmarkActiveIconSize);
                height: var(--headerBookmarkActiveIconSize);
                background: var(--primaryColor2);
                border: 1px solid  var(--primaryColor3);
                border-radius: 50%;
                box-sizing: border-box;
                transform: translate3d(50%, -50%, 0);
                opacity: 0;
                transition: var(--trTime);
            }

            &.active {
                &:after {
                    opacity: 1;
                }
            }
        }
    }
`

export default BottomTabNavigationStyle